// extracted by mini-css-extract-plugin
export default {"WorkWithUs":"WorkWithUs_WorkWithUs__+7PEg","heading":"WorkWithUs_heading__U9bD9"};